<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/personvern-og-cookies" />
</template>
